import { createAsyncThunk } from '@reduxjs/toolkit';

import { antiPirateApi } from '~/api/antiPirate/antiPirateApi';
import { IdentifyByBookParams, IdentifyByChapterParams } from '~/api/antiPirate/antiPirateApiTypes';
import { defaultErrorMessage, HttpNotFoundError } from '~/api/provider/providerErrors';
import {
  antiPirateActions,
  antiPirateSliceName,
} from '~/atomic/page/anti-pirate/check/antiPirate.slice';

export const identifyThePirate = createAsyncThunk<
void,
IdentifyByBookParams | IdentifyByChapterParams,
{ rejectValue: { error: string }; }
>(
  `${antiPirateSliceName}/identifyThePirate`,
  async (
    data,
    thunkAPI,
  ) => {
    thunkAPI.dispatch(antiPirateActions.setIsIdentifyLoading(true));
    thunkAPI.dispatch(antiPirateActions.setResult(null));
    if (data && 'slug' in data) {
      await thunkAPI.dispatch(identifyThePirateByBook(data));
    }

    if (data && 'chapterId' in data) {
      await thunkAPI.dispatch(identifyThePirateByChapter(data));
    }

    thunkAPI.dispatch(antiPirateActions.setIsIdentifyLoading(false));
  },
);

export const identifyThePirateByBook = createAsyncThunk<
void,
IdentifyByBookParams,
{ rejectValue: { error: string }; }
>(
  `${antiPirateSliceName}/identifyThePirateByBook`,
  async (
    data,
    thunkAPI,
  ) => {
    try {
      const result = await antiPirateApi.identifyByBook(data);
      if (result && 'message' in result) {
        thunkAPI.dispatch(antiPirateActions.setResult('success'));
      } else {
        thunkAPI.dispatch(antiPirateActions.setResult('fail'));
        thunkAPI.dispatch(antiPirateActions.setErrorMessage(defaultErrorMessage));
      }
    } catch (e) {
      if (e.message) {
        if (e instanceof HttpNotFoundError) {
          thunkAPI.dispatch(antiPirateActions.setNotFoundError(e.message));
        } else {
          thunkAPI.dispatch(antiPirateActions.setErrorMessage(e.message));
          thunkAPI.dispatch(antiPirateActions.setResult('fail'));
        }
      }
    }
  },
);

export const identifyThePirateByChapter = createAsyncThunk<
void,
IdentifyByChapterParams,
{ rejectValue: { error: string }; }
>(
  `${antiPirateSliceName}/identifyThePirateByChapter`,
  async (
    data,
    thunkAPI,
  ) => {
    try {
      const result = await antiPirateApi.identifyByChapter(data);
      if (result && 'message' in result) {
        thunkAPI.dispatch(antiPirateActions.setResult('success'));
      } else {
        thunkAPI.dispatch(antiPirateActions.setResult('fail'));
        thunkAPI.dispatch(antiPirateActions.setErrorMessage(defaultErrorMessage));
      }
    } catch (e) {
      if (e.message) {
        thunkAPI.dispatch(antiPirateActions.setErrorMessage(e.message));
      }
      thunkAPI.dispatch(antiPirateActions.setResult('fail'));
    }
  },
);
